const styles = {
  error: {
    fontSize: ".8rem"
  }
};

export default styles;
